import React from 'react';

const Loader = () => {
  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: '#FFFFFF',
      zIndex: 9999,
      perspective: '900px'
    }}>
      <img 
        src="Images/Loader.png" 
        alt="Loading..." 
        style={{
          width: '100px',
          height: '100px',
          animation: 'flipLogo 2s linear infinite',
          transformStyle: 'preserve-3d'
        }}
      />
      <style>
        {`
          @keyframes flipLogo {
            0% {
              transform: rotateY(0deg);
            }
            100% {
              transform: rotateY(360deg);
            }
          }
        `}
      </style>
    </div>
  );
};

export default Loader;